import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import AppReducer from '../common/reducers/AppReducer';
import DruidReducer from '../common/reducers/DruidReducer';
import OnboardingLinkReducer from '../common/reducers/OnboardingLinkReducer';
import Org from '../common/reducers/OrgReducer';
import ShareableReducer from '../common/reducers/ShareableReducer';
import UserEntityTerms from '../common/reducers/UserEntityTermsReducer';
import UserOnboardingDataReducer from '../common/reducers/UserOnboardingDataReducer';
import AccessControl from '../main/reducers/AccessControlReducer';
import Activity from '../main/reducers/ActivityReducer';
import AdLinkTemplateReducer from '../main/reducers/AdLinkTemplateReducer/AdLinkTemplateReducer';
import AgencyRelationshipReducer from '../main/reducers/AgencyRelationshipReducer';
import AlertNotificationsReducer from '../main/reducers/AlertNotificationsReducer';
import AppCategoryReducer from '../main/reducers/AppCategoryReducer';
import AppStoreVerification from '../main/reducers/AppStoreVerificationReducer';
import AppleSearchAds from '../main/reducers/AppleSearchAdsReducer';
import Audience from '../main/reducers/AudienceReducer';
import AuthServiceReducer from '../main/reducers/AuthServiceReducer';
import BillingAccount from '../main/reducers/BillingAccountReducer';
import Cnames from '../main/reducers/CnamesReducer';
import Collection from '../main/reducers/CollectionReducer/CollectionReducer';
import CsvExport from '../main/reducers/CsvExport';
import CustomCalculationReducer from '../main/reducers/CustomCalculationReducer';
import BranchCustomExport from '../main/reducers/CustomExportReducer/BranchCustomExportReducer';
import TuneCustomExport from '../main/reducers/CustomExportReducer/TuneCustomExportReducer';
import DataIntegrations from '../main/reducers/DataIntegrationsReducer';
import Deepview from '../main/reducers/DeepviewReducer';
import DiscoAds from '../main/reducers/DiscoAdsReducer';
import DomainLinks from '../main/reducers/DomainLinksReducer';
import EmailOnboarding from '../main/reducers/EmailOnboarding';
import EventsReducer from '../main/reducers/Events/EventsReducer';
import Facebook from '../main/reducers/FacebookReducer';
import FraudFighter from '../main/reducers/FraudFighterReducer';
import Fraud from '../main/reducers/FraudReducer';
import Google from '../main/reducers/GoogleReducer';
import HealthCheckReducer from '../main/reducers/HealthCheckReducer';
import Invoices from '../main/reducers/InvoicesReducer';
import LinkCreator from '../main/reducers/LinkCreatorReducer';
import CreationDialogReducer from '../main/reducers/LinkManager/CreationDialogReducer';
import LinkByQueryReducer from '../main/reducers/LinkManager/LinkByQueryReducer';
import LogoutModal from '../main/reducers/LogoutModalReducer';
import MicroFrontends from '../main/reducers/MicroFrontendsReducer';
import PaymentMethods from '../main/reducers/PaymentMethodsReducer';
import Payments from '../main/reducers/PaymentsReducer';
import PbaLiveview from '../main/reducers/PbaLiveviewReducer';
import PersonaServiceReducer from '../main/reducers/PersonaServiceReducer';
import PrebuiltMacrosReducer from '../main/reducers/PrebuiltMacros/PrebuiltMacrosReducer';
import QuickLinkCreatorReducer from '../main/reducers/QuickLinkCreatorReducer/QuickLinkCreatorReducer';
import QuickLinkTemplateReducer from '../main/reducers/QuickLinkTemplateReducer';
import QuickLinksReducer from '../main/reducers/QuickLinksReducer';
import SDKInfo from '../main/reducers/SDKInfoReducer';
import Schedule from '../main/reducers/ScheduleReducer';
import Snap from '../main/reducers/SnapReducer';
import SSO from '../main/reducers/SsoReducer';
import StatusReducer from '../main/reducers/StatusReducer';
import Subscriptions from '../main/reducers/SubscriptionsReducer';
import Team from '../main/reducers/TeamReducer';
import ThirdPartyGlobalSettings from '../main/reducers/ThirdPartyGlobalSettingsReducer';
import ThirdPartyProviderConfig from '../main/reducers/ThirdPartyProviderConfigReducer';
import Twitter from '../main/reducers/TwitterReducer';
import Webhooks from '../main/reducers/WebhooksReducer';
import WhitelistedDeviceOrmReducer from '../main/reducers/WhitelistedDeviceOrmReducer';
import { dashApiInterceptorSetup } from '../main/support/dash_api';
import { serverReduxSetup } from '../main/support/server';
import StartReducer from '../start/reducers/StartReducer';
import TwilioStartReducers from '../start/reducers/TwilioStartReducers';
import AdLinkCreatorReducer from './domains/AdLinkCreator/AdLinkCreator.reducer';
import AdLinks from './domains/AdLinks/AdLinks.reducer';
import AdPartner from './domains/AdPartner/AdPartner.reducer';
import Criteo from './domains/AdPartner/Criteo/Criteo.reducer';
import GoogleAds from './domains/AdPartner/Google/Ads/GoogleAds.reducer';
import GoogleMarketingPlatform from './domains/AdPartner/Google/MarketingPlatform/GoogleMarketingPlatform.reducer';
import Pinterest from './domains/AdPartner/Pinterest/Pinterest.reducer';
import RTBHouse from './domains/AdPartner/RTBHouse/RTBHouse.reducer';
import Reddit from './domains/AdPartner/Reddit/Reddit.reducer';
import Tiktok from './domains/AdPartner/TikTok/TikTok.reducer';
import TiktokSAN from './domains/AdPartner/TikTokSAN/TikTokSAN.reducer';
import AllowanceReducer from './domains/Allowance/Allowance.reducer';
import AppStoreReducer from './domains/AppStore/AppStore.reducer';
import BranchAccountReducer from './domains/BranchAccount/BranchAccount.reducer';
import CostFileTemplateReducer from './domains/CostFileTemplate/CostFileTemplate.reducer';
import CostFileTemplateCreatorReducer from './domains/CostFileTemplateCreator/CostFileTemplateCreator.reducer';
import EmailIngestorReducer from './domains/EmailIngestor/EmailIngestor.reducer';
import FileIngestorReducer from './domains/FileIngestor/FileIngestor.reducer';
import FlipperUpdates from './domains/FlipperUpdates/Flipper.reducer';
import JourneysReducer from './domains/Journeys/Journeys.reducer';
import LinkHubCreatorReducer from './domains/LinkHubCreator/LinkHubCreator.reducer';
import LinkHubCustomerReducer from './domains/LinkHubCustomer/LinkHubCustomer.reducer';
import QrCodeLinkCreatorReducer from './domains/QrCodeLinkCreator/QrCodeLinkCreator.reducer';
import QrCodeLinkManagerFilterReducer from './domains/QrCodeLinkManagerFilter/QrCodeLinkManagerFilter.reducer';
import SKANConversionValueMappingReducer from './domains/SKANConversionValueMapping/SKANPostbacksConversionMapping.reducer';
import SKAdnetwork from './domains/SKAdNetwork/SKAdNetwork.reducer';
import UsageReducer from './domains/Usage/Usage.reducer';
import UserReducer from './domains/User/User.reducer';

export const reducers = {
  accessControl: AccessControl,
  activity: Activity,
  ad_links: AdLinks,
  ad_partner: AdPartner,
  adLinkCreator: AdLinkCreatorReducer,
  ad_link_templates: AdLinkTemplateReducer,
  agencyRelationship: AgencyRelationshipReducer,
  alertNotifications: AlertNotificationsReducer,
  allowance: AllowanceReducer,
  app: AppReducer,
  app_status: StatusReducer,
  app_category: AppCategoryReducer,
  appStore: AppStoreReducer,
  appStoreVerification: AppStoreVerification,
  apple_search_ads: AppleSearchAds,
  audience: Audience,
  auth_service: AuthServiceReducer,
  billing_account: BillingAccount,
  branchAccount: BranchAccountReducer,
  branchCustomExport: BranchCustomExport,
  cnames: Cnames,
  collection: Collection,
  creationDialog: CreationDialogReducer,
  csvExport: CsvExport,
  customCalculations: CustomCalculationReducer,
  dataIntegrations: DataIntegrations,
  deepview: Deepview,
  disco_ads: DiscoAds,
  domainLinks: DomainLinks,
  druid: DruidReducer,
  emailOnboarding: EmailOnboarding,
  events: EventsReducer,
  facebook: Facebook,
  fileIngestor: FileIngestorReducer,
  emailIngestor: EmailIngestorReducer,
  costFileTemplate: CostFileTemplateReducer,
  costFileTemplateCreator: CostFileTemplateCreatorReducer,
  flipper_updates: FlipperUpdates,
  fraud: Fraud,
  fraud_fighter: FraudFighter,
  google: Google,
  google_ads: GoogleAds,
  google_marketing_platform: GoogleMarketingPlatform,
  health_checks: HealthCheckReducer,
  invoices: Invoices,
  journey: JourneysReducer,
  link_by_query: LinkByQueryReducer,
  linkCreator: LinkCreator,
  linkHubCreator: LinkHubCreatorReducer,
  linkHubCustomer: LinkHubCustomerReducer,
  logout_modal: LogoutModal,
  micro_frontends: MicroFrontends,
  ob_link: OnboardingLinkReducer,
  onboarding: StartReducer,
  org: Org,
  payments: Payments,
  payment_methods: PaymentMethods,
  persona_service: PersonaServiceReducer,
  pba_liveview: PbaLiveview,
  prebuiltMacros: PrebuiltMacrosReducer,
  qrCodeLinkCreator: QrCodeLinkCreatorReducer,
  qrCodeLinkManagerFilter: QrCodeLinkManagerFilterReducer,
  quickLinkCreator: QuickLinkCreatorReducer,
  quick_link_templates: QuickLinkTemplateReducer,
  quick_links: QuickLinksReducer,
  schedule: Schedule,
  sdk_info: SDKInfo,
  shareable: ShareableReducer,
  skadnetwork: SKAdnetwork,
  skan_conversion_value_mapping: SKANConversionValueMappingReducer,
  snap: Snap,
  pinterest: Pinterest,
  criteo: Criteo,
  reddit: Reddit,
  rtbHouse: RTBHouse,
  sso: SSO,
  subscriptions: Subscriptions,
  team: Team,
  third_party_global_settings: ThirdPartyGlobalSettings,
  third_party_provider_config: ThirdPartyProviderConfig,
  tiktok: Tiktok,
  tiktok_san: TiktokSAN,
  tuneCustomExport: TuneCustomExport,
  twilio: TwilioStartReducers,
  twitter: Twitter,
  usage: UsageReducer,
  user: UserReducer,
  userEntityTerms: UserEntityTerms,
  userOnboardingData: UserOnboardingDataReducer,
  webhook: Webhooks,
  whitelist_devices: WhitelistedDeviceOrmReducer,
};

const app = combineReducers(reducers);

const composeEnhancers =
  // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
  process.env.NODE_ENV != 'production' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: 'Dashboard',
      })
    : compose;

const getMiddlewares = () => {
  return [thunk];
};

const enhancer = composeEnhancers(applyMiddleware(...getMiddlewares()));

const store = createStore(app, enhancer);

dashApiInterceptorSetup(store);
serverReduxSetup(store);

export default store;
